import React, { useEffect, useRef, useState } from "react"
import { NotificationsButton } from "../NotificationsButton"
import { Box, Menu, MenuItem } from "@material-ui/core"
import { OnlineOfflineUserBadge } from "components/OnlineOfflineUserBadge"
import { ImageLoader } from "components/ImageLoader"
import { useNotification } from "hooks/notification"
import { useAuth } from "hooks/auth"
import { getRequest } from "utils/request"
import { TMenu } from "definitions/Others"
import { useHistory } from "react-router-dom"
import { translate } from "translate/i18n"

const I18N_STORAGE_KEY = "i18nextLng"

const localLanguage = localStorage.getItem(I18N_STORAGE_KEY)

export function HeaderRightPane(): JSX.Element {
  const history = useHistory()
  const { isNetworkOnline, selectedCompany } = useNotification()
  //@ts-ignore waiting for typification of useAuth
  const { user, signOut } = useAuth()
  const [userPhoto, setUserPhoto] = useState("")
  const [userName, setUserName] = useState("")
  const [role, setRole] = useState("")
  const [menus, setMenus] = useState<TMenu[]>([])
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false)

  const menuAnchor = useRef<HTMLDivElement>(null)

  const searchUserMenu = async () => {
    if (Number(selectedCompany.id) >= 0) {
      const menusResponse = await getRequest<TMenu[]>(
        `/menus?UserTypeId=${user.UserTypeId}&CompanyId=${selectedCompany.id}`
      )
      if (menusResponse.success) {
        let listmenu: TMenu[] = []
        menusResponse.data.forEach((data) => {
          if (data.type === "H") {
            if (data.MenuId === 16 && user.password) {
              listmenu.push(data)
            } else {
              listmenu.push(data)
            }
          }
        })
        setMenus(listmenu)
      }
    }
  }

  const handleLogoff = async () => {
    await signOut()
    history.push("/")
  }

  const redirectMenu = (data: TMenu) => {
    if (data.link === "/company") {
      if (selectedCompany.id !== 0) {
        history.push(
          `../../../../../dashboard/editcompany/${selectedCompany.id}`
        )
      } else {
        history.push(`../../../../../dashboard${data.link}`)
      }
    } else {
      history.push(`../../../../../dashboard${data.link}`)
    }
  }

  const handleMenuClick = () => {
    setIsUserMenuOpen((prev) => !prev)
  }

  const handleMenuClose = () => {
    setIsUserMenuOpen(false)
  }

  useEffect(() => {
    searchUserMenu()
  }, [selectedCompany])

  useEffect(() => {
    setUserName(user.nickName)
    setUserPhoto(user.photo)
    setRole(user?.UserType?.description)

    if (user.language !== localLanguage) {
      localStorage.setItem(I18N_STORAGE_KEY, user.language)
      window.location.reload()
    }
  }, [])

  return (
    <div
      style={{
        display: "flex",
        height: "var(--header-height)",
        position: "relative",
        backgroundColor: "buttonface",
      }}
    >
      <NotificationsButton />
      <Box
        component="button"
        style={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          border: 0,
          height: "100%",
        }}
        onClick={handleMenuClick}
      >
        <OnlineOfflineUserBadge
          online={isNetworkOnline}
          isPaused={false}
          position={{ top: 10, left: 0 }}
        />
        <ImageLoader
          imgUrl={!!user.photo ? user.photo : userPhoto}
          resourceType="avatar"
          alt="avatar"
          className="img-avatr-user-header"
          whosCalling="Header 589"
        />
        <div className="area-text-header-name-cargo">
          <span className="text-name-user-header">
            {!!user.name ? user.name : userName}
          </span>
          <span className="text-cargo-header">{role}</span>
        </div>
      </Box>
      {/* foi mais facil controlar a posição usando um anchor div com absolute position
        do que configurar o posicionamento do component Menu do material-ui
      */}
      <div
        ref={menuAnchor}
        style={{
          position: "absolute",
          bottom: "-28px",
          right: 0,
        }}
      ></div>
      <Menu
        anchorEl={menuAnchor.current}
        keepMounted
        open={isUserMenuOpen}
        onClose={handleMenuClose}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {menus.map((data, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              redirectMenu(data)
              handleMenuClose()
            }}
          >
            {data.description}
          </MenuItem>
        ))}
        <MenuItem
          onClick={() => {
            handleLogoff()
            handleMenuClose()
          }}
        >
          {translate("exit")}
        </MenuItem>
      </Menu>
    </div>
  )
}
